export const getSortParam = ({ column, direction }) =>
  `${direction === 'desc' ? '-' : ''}${column}`;
